<mat-form-field
        [ngClass]="wrapperClasses"
        [appearance]="input.appearance"
        [floatLabel]="input.floatLabel" class="full-width">
    <mat-label>{{input.label}}</mat-label>
    <mat-chip-list #chipList [disabled]="input.control.disabled">
        <mat-chip *ngFor="let chip of chips" [value]="chip[input.property]" (removed)="remove(chip[input.property])">
            <span>{{chip[input.display]}}</span>
            <button [hidden]="input.control.disabled" type="button" matChipRemove class="margin-bottom-sm">
                <mat-icon matTooltip="Remove this">cancel</mat-icon>
            </button>
        </mat-chip>
        <input
                #searchInput
                [formControl]="searchControl"
                [placeholder]="input.placeholder"
                [matAutocomplete]="auto"
                [matChipInputFor]="chipList">
        <mat-autocomplete #auto
                          (blur)="blurEvent($event)"
                          (focus)="focusEvent($event)"
                          [aria-labelledby]="auto.id + editPromptSuffix"
                          (optionSelected)="selected($event)">
            <mat-option *ngFor="let option of options" [value]="option">
                {{option[input.display]}}
            </mat-option>
        </mat-autocomplete>
    </mat-chip-list>
    <div class="loading-text" [hidden]="!loading">
        <mat-progress-spinner mode="indeterminate" color="primary" diameter="20"></mat-progress-spinner>
        Searching...
    </div>
    <div class="loading-text text-error" *ngIf="errorLoading">Error loading options!</div>
    <div class="loading-text text-error" *ngIf="noSearchResultsFound">Nothing found for your query!</div>
    <mat-error>{{errorMessage}}</mat-error>
    <mat-hint [ngClass]="hint?.class">{{hint?.message}}</mat-hint>
</mat-form-field>
